import React, { useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function EntryDialog({ open, onUpdate, onClose, entry }) {
    const [entryLabel, setEntryLabel] = useState(entry.label);
    const [vat, setVAT] = React.useState(entry.vat_rate);

    const VAT_RATES = {
        NOR: '20 %',
        MID: '10 %',
        RED: '5,5 %',
        SPE: '2,1 %',
        NUL: '0 %',
        ND: 'indéterminé',
    };

    const handleSubmit = () => {
        const updatedEntry = { ...entry, label: entryLabel, vat_rate: vat };
        onUpdate(updatedEntry); // Mets à jour l'entry
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Modifier la transaction</DialogTitle>
            <DialogContent>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel id="select-vat-input-label">TVA</InputLabel>
                    <Select
                        labelId="select-vat-input-label"
                        id="select-vat-select"
                        value={vat}
                        onChange={(event) => {
                            setVAT(event.target.value);
                          }}
                        label="TVA"
                    >
                        {Object.entries(VAT_RATES).map(([key, rate]) => (
                            <MenuItem key={key} value={key}>{rate}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Label"
                    type="text"
                    fullWidth
                    value={entryLabel}
                    onChange={(e) => setEntryLabel(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Annuler</Button>
                <Button onClick={handleSubmit} color="primary">Enregistrer</Button>
            </DialogActions>
        </Dialog>
    );

};